import $ from "jquery";

function BusinessAreaVideo(el) {
    const $el = $(el);
    const $video = $el.find(".card-business__video")[0];

    const isTouchDevice = 'ontouchend' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    if (!isTouchDevice) {
        $el.on("mouseenter", function () {
            if ($video) {
                $video.play();
            }
        });

        $el.on("mouseleave", function () {
            if ($video) {
                $video.pause();
            }
        });
    } else {

        $el.addClass('card-business--mobile');
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    $video.play();
                } else {
                    $video.pause();
                }
            });
        });

        if ($video) {
            observer.observe($video);
        }
    }
}

export default BusinessAreaVideo;
